module.exports = "./img/7d94e9b80bae7aa83c7eeaea69a969c8.jpg";